// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileZippedNewIconSignature {
  Element: SVGSVGElement;
}

export const FileZippedNewIcon: TOC<FileZippedNewIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 2H18C19.103 2 20 2.896 20 4V20C20 21.103 19.103 22 18 22H6C4.897 22 4 21.103 4 20V4C4 2.896 4.897 2 6 2ZM6 4V20H18.001L18 4H14V6H12V4H6ZM14 8V6H16V8H14ZM14 10H12V8H14V10ZM14 12H16V10H14V12ZM14 12V14H12V12H14Z"/>
</svg>
</template>;